import { render, staticRenderFns } from "./QuestionTextarea.vue?vue&type=template&id=93aba8fa&scoped=true&"
import script from "./QuestionTextarea.vue?vue&type=script&lang=js&"
export * from "./QuestionTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93aba8fa",
  null
  
)

export default component.exports